import type { SearchPassenger } from "@busbud/core-types/dist/lib/search-info";
import { DiscountType } from "@busbud/int-schemas";

import type { SearchInfo } from "@app/types/search-types";

export function getPassengersDiscounts(
  search: Omit<SearchInfo, "origin" | "destination">,
  category: SearchPassenger["category"]
) {
  const paxs_discounts: SearchPassenger["discounts"][] = [];

  // Adult doesn't have age, so isn't necessary to assign to a specific age
  if (category === "adult") {
    for (let idx = 0; idx < search.adult_student; idx++) {
      paxs_discounts.push([DiscountType.Student]);
    }

    return paxs_discounts;
  }

  // Pet doesn't have age or student discount
  if (category === "pet") {
    return paxs_discounts;
  }

  // In the actual search_form slice, on redux state, each category's ages arrays(ex: child_ages, child_student_ages, ...) have the length of the number of passengers of the category.
  // The `[category]_student_ages` and `[category]_wheelchair_ages` arrays are initialized with `-1` values for each index. If the index contains the age of the passenger instead of -1, it means the passenger selected this discount/option.

  const search_info_category = category === "youth" ? "child" : category;
  const category_count = search[search_info_category];
  const students_ages = search[`${search_info_category}_student_ages`];

  for (let idx = 0; idx < category_count; idx++) {
    // @ts-expect-error TS2532 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
    const discount = students_ages[idx] > -1 ? [DiscountType.Student] : [];
    paxs_discounts.push(discount);
  }

  return paxs_discounts;
}
